import React from 'react';
import PropTypes from 'prop-types';
import Geosuggest from 'react-geosuggest';
import { Card, Title, BtnGroup, Option, HomeAddress } from '../survey.css';

const WhereIsYourHome = ({ setAddress, address, goFwd, background }) => {
  return (
    <Card background={background}>
      <Title>Where is your home?</Title>

      <BtnGroup>
        <HomeAddress>
          <Geosuggest
            onSuggestSelect={setAddress}
            placeholder="Enter your address"
          />
        </HomeAddress>

        <Option disabled={address === null} onClick={() => goFwd(3)}>
          {address ? 'Submit' : 'Find Your Address'}
        </Option>
      </BtnGroup>
    </Card>
  );
};

WhereIsYourHome.propTypes = {
  setAddress: PropTypes.func.isRequired,
  address: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  background: PropTypes.bool,
  nextStep: PropTypes.number.isRequired,
  goFwd: PropTypes.func.isRequired,
};

export default WhereIsYourHome;
